<template>
  <div v-show="isLoading" class="spinner-overlay">
    <div class="spinner"></div>
  </div>
</template>

<script>
import useSpinner from "@/composables/useSpinner";

export default {
  name: 'LoadingOverlay',
  setup() {
    const { isLoading } = useSpinner();

    return {
      isLoading,
    };
  },
}
</script>


<style scoped>

.spinner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.spinner {
  border: 16px solid #e9e9e9;
  border-top: 16px solid #2e8e83;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
